import { Box } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, ColorSchema, useMinimalsTheme } from '@tom-ui/ui'
import { FC } from 'react'

export type CarrierVisitStatusType =
  | 'Expected'
  | 'Arrived'
  | 'Berthed'
  | 'InOperation'
  | 'OperationCompleted'
  | 'Departed'
  | 'Completed'
  | 'Closed'
  | 'Cancelled'

type Props = {
  status: CarrierVisitStatusType
  isBerthed?: boolean
}

export const CarrierVisitStatusChip: FC<Props> = props => {
  const { status, isBerthed } = props
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const colorMap: Record<CarrierVisitStatusType, ColorSchema> = {
    Expected: 'info',
    Arrived: 'primary',
    Berthed: 'primary',
    InOperation: 'busy',
    OperationCompleted: 'primary',
    Completed: 'primary',
    Departed: 'primary',
    Closed: 'secondary',
    Cancelled: 'secondary',
  }

  const color = colorMap[status] ?? 'secondary'

  let backgroundColor: string

  if (status === 'Cancelled') {
    backgroundColor = theme.palette.grey[300]
  } else if (status === 'Closed') {
    backgroundColor = theme.palette.grey[200]
  } else {
    backgroundColor = theme.palette[color].lighter
  }

  const label = status === 'Arrived' && isBerthed ? 'Berthed' : status

  return (
    <Box data-cy='carrier-visit-status-chip'>
      <ColoredLabel
        label={t(label)}
        color={color}
        sx={{
          width: 'fit-content',
          backgroundColor,
        }}
      />
    </Box>
  )
}
